import BaseResource from './BaseResource';

export interface CharacterVoiceData {
  service: string;
  code: string;
  accent: string;
  speed: {
    beginner: number;
    intermediate: number;
    advanced: number;
  };
}

export interface CharacterData {
  id: string;
  name?: string;
  avatar?: string;
  voice?: CharacterVoiceData;
}

class CharacterResource extends BaseResource<CharacterData> {
  static get storeName(): string {
    return 'CharacterResource';
  }

  static get endpoint(): string {
    return `/coach/characters`;
  }

  static toObject(raw: any): CharacterResource {
    return new CharacterResource(raw as CharacterData);
  }
}

export default CharacterResource;
